var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("jade-box", { attrs: { title: _vm.$t(_vm.title), hasPadding: "" } }, [
        _vm.loading
          ? _c(
              "div",
              {
                staticClass: "eu-pa_6 eu-align_center",
                attrs: { "data-testid": "show-loading" },
              },
              [_c("jade-spinner")],
              1
            )
          : _c(
              "div",
              { staticClass: "flex flex-col gap-3" },
              [
                _vm._l(_vm.parsedHistoryFields, function (historyField, index) {
                  return _c(
                    "div",
                    { key: historyField.label },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex w-full justify-between items-center gap-1 mb-3",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-col" },
                            [
                              _c(
                                "jade-text",
                                {
                                  attrs: {
                                    color: "medium",
                                    variant: "text-small",
                                  },
                                },
                                [_vm._v(" " + _vm._s(historyField.label) + " ")]
                              ),
                              historyField.isDateField
                                ? _c(
                                    "jade-text",
                                    {
                                      attrs: {
                                        color: "high",
                                        weight: "semibold",
                                        variant: "text-medium",
                                        "data-testid": historyField.testId,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("dateFormat")(
                                              historyField.value,
                                              "dateAndHour"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : historyField.isLink
                                ? _c(
                                    "jade-text",
                                    {
                                      staticClass: "underline",
                                      attrs: {
                                        color: "high",
                                        weight: "semibold",
                                        variant: "text-medium",
                                        as: "a",
                                        target: "_blank",
                                        href: _vm.$sanitize(historyField.href),
                                        "data-testid": historyField.testId,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(historyField.value) + " "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "jade-text",
                                    {
                                      attrs: {
                                        color: "high",
                                        weight: "semibold",
                                        variant: "text-medium",
                                        "data-testid": historyField.testId,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(historyField.value) + " "
                                      ),
                                    ]
                                  ),
                            ],
                            1
                          ),
                          historyField.copyText
                            ? _c("jade-icon-button", {
                                attrs: { size: "small", icon: "action-copy" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copyToClipboard(
                                      historyField.copyText
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      index < _vm.parsedHistoryFields?.length - 1
                        ? _c("jade-divider", { staticClass: "history-divider" })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                _vm.technicianTrackingLink
                  ? _c(
                      "jade-alert",
                      {
                        attrs: {
                          variant: "neutral",
                          icon: "circle-info",
                          showIcon: "",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex flex-col gap-2" },
                          [
                            _c(
                              "jade-text",
                              {
                                attrs: {
                                  color: "high",
                                  variant: "text-medium",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("tracking-alert-label")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "flex items-center gap-1" },
                              [
                                _vm.technicianTrackingLink
                                  ? _c(
                                      "jade-text",
                                      {
                                        staticClass: "underline",
                                        attrs: {
                                          as: "a",
                                          weight: "semibold",
                                          href: _vm.$sanitize(
                                            _vm.technicianTrackingLink
                                          ),
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("tracking-alert-button")
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c("jade-icon", {
                                  attrs: {
                                    size: "small",
                                    use: "chevron-right",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              2
            ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }